import { render, staticRenderFns } from "./PledgPayment.vue?vue&type=template&id=85f23e90"
import script from "./PledgPayment.vue?vue&type=script&lang=js"
export * from "./PledgPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports